module.exports = __webpack_public_path__ + "static/img/videoCover.b6eab5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/videoCover.jpg
// module id = aKv0
// module chunks = 21